function Button({name}) {
    return(
<button className="location-btn">{name}</button>
    );
}
export default Button